module.exports = {"350427001":"凤岗街道","350427002":"虬江街道","350427101":"青州镇","350427102":"夏茂镇","350427104":"高砂镇","350427105":"高桥镇","350427106":"富口镇","350427107":"大洛镇","350427201":"南霞乡","350427203":"南阳乡","350427204":"郑湖乡","350427205":"湖源乡","350427400":"金沙园开发区","350427401":"金古园开发区","350427402":"青山纸业工业区","350427403":"海西物流园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350427.json
// module id = 1303
// module chunks = 0